import PropTypes from 'prop-types';
import React from 'react';
import { Heart } from 'lucide-react';
import styles from './TalentPoolHeart.module.scss';

const FILL_RED = '#D9534F';
const DEFAULT_TITLE = 'Adds/Removes freelancer from your Talent Pool';

/**
 * Talent pool toggle: outline heart when not shortlisted, filled when shortlisted.
 * With `browseUsername`, emits data attrs for BrowseTest delegated clicks.
 */
const TalentPoolHeart = ({ browseUsername, iconSize, shortlistState }) => {
  const ariaLabel = shortlistState
    ? 'Remove from talent pool'
    : 'Add to talent pool';

  const trimmed =
    browseUsername != null && String(browseUsername).trim() !== ''
      ? String(browseUsername).trim()
      : '';
  const browseProps =
    trimmed !== ''
      ? { 'data-browse-shortlist': '1', 'data-username': trimmed }
      : {};

  const rootClass = [
    styles.root,
    !shortlistState ? styles.root_isOutline : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={rootClass}
      title={DEFAULT_TITLE}
      aria-label={ariaLabel}
      aria-pressed={shortlistState ? 'true' : 'false'}
      {...browseProps}
    >
      {shortlistState ? (
        <Heart
          className={styles.filled}
          size={iconSize}
          fill={FILL_RED}
          color={FILL_RED}
          stroke={FILL_RED}
          strokeWidth={0}
          aria-hidden={true}
        />
      ) : (
        <Heart
          className={styles.outline}
          size={iconSize}
          fill="none"
          stroke="currentColor"
          strokeWidth={1.75}
          aria-hidden={true}
        />
      )}
    </button>
  );
};

TalentPoolHeart.propTypes = {
  browseUsername: PropTypes.string,
  iconSize: PropTypes.number,
  shortlistState: PropTypes.bool,
};

TalentPoolHeart.defaultProps = {
  browseUsername: null,
  iconSize: 18,
  shortlistState: false,
};

export default TalentPoolHeart;
